var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingAccountPromotionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F2F4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 37.5C20 38.7476 20.2457 39.9829 20.7231 41.1355C21.2006 42.2881 21.9003 43.3354 22.7825 44.2175C23.6646 45.0997 24.7119 45.7994 25.8645 46.2769C27.0171 46.7543 28.2524 47 29.5 47C30.7476 47 31.9829 46.7543 33.1355 46.2769C34.2881 45.7994 35.3354 45.0997 36.2175 44.2175C37.0997 43.3354 37.7994 42.2881 38.2769 41.1355C38.7543 39.9829 39 38.7476 39 37.5C39 36.2524 38.7543 35.0171 38.2769 33.8645C37.7994 32.7119 37.0997 31.6646 36.2175 30.7825C35.3354 29.9003 34.2881 29.2006 33.1355 28.7231C31.9829 28.2457 30.7476 28 29.5 28C28.2524 28 27.0171 28.2457 25.8645 28.7231C24.7119 29.2006 23.6646 29.9003 22.7825 30.7825C21.9003 31.6646 21.2006 32.7119 20.7231 33.8645C20.2457 35.0171 20 36.2524 20 37.5Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 34.8757C31.6824 34.6009 31.463 34.3743 31.1988 34.2202C30.9346 34.0661 30.6354 33.9903 30.3333 34.001H28.6667C28.2246 34.001 27.8007 34.1853 27.4882 34.5134C27.1756 34.8415 27 35.2865 27 35.7505C27 36.2145 27.1756 36.6595 27.4882 36.9876C27.8007 37.3157 28.2246 37.5 28.6667 37.5H30.3333C30.7754 37.5 31.1993 37.6843 31.5118 38.0124C31.8244 38.3405 32 38.7855 32 39.2495C32 39.7135 31.8244 40.1585 31.5118 40.4866C31.1993 40.8147 30.7754 40.999 30.3333 40.999H28.6667C28.3646 41.0097 28.0654 40.9339 27.8012 40.7798C27.537 40.6257 27.3176 40.3991 27.1667 40.1243",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41L30 43",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 32L30 34",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22L30 28",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5683 25.795C29.5683 25.795 25.1713 25.4783 22.2641 22.571C19.3568 19.6638 19.0401 15.2668 19.0401 15.2668C19.0401 15.2668 23.6638 15.3568 26.571 18.2641C29.4783 21.1713 29.5683 25.795 29.5683 25.795Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.795 11.2668C40.795 11.2668 40.4783 15.6637 37.571 18.571C34.6638 21.4782 30.2668 21.7949 30.2668 21.7949C30.2668 21.7949 30.3568 17.1713 33.2641 14.264C36.1713 11.3567 40.795 11.2668 40.795 11.2668Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingAccountPromotionIcon);
export default __webpack_public_path__ + "static/media/saving-account-promotion-icon.1965e1ad474b63e052c5bcfd3adbb001.svg";
export { ForwardRef as ReactComponent };